export enum OfferStatus {
    Created = 'STATUS_CREATED',
    Pending = 'STATUS_PENDING',
    Accepted = 'STATUS_ACCEPTED',
    Declined = 'STATUS_DECLINED',
}
